@if (!compact) {
@if (loading) {
<mat-progress-bar mode="indeterminate"></mat-progress-bar>
}
@if (!loading && jobRecord) {
<dl>
  @if (!loading && !error &&jobRecord) {
  <dd>{{ jobRecord.Jobf_JobDescription }}</dd>
  }
  @if (!loading && error) {
  <dd>
    <mat-icon fontIcon="fa-unlink" fontSet="fas"
      style="font-size: 16px; vertical-align: middle; margin-right: 5px;"></mat-icon>
    Unable to retrieve Job Description from Core
  </dd>
  }
</dl>
}
}
@if (compact) {
@if (!loading && !error && jobRecord) {
<span style="padding:5px; color: #000000DE;">{{ jobRecord.Jobf_JobDescription }}</span>
}
@if (!loading && error) {
<span style="display: flex; align-items: center;">
  <mat-icon fontIcon="fa-unlink" fontSet="fas" style="font-size: 16px; margin-right: 5px;"></mat-icon>
  Unable to obtain property details from Core
</span>
}
}
